import { JointTexture } from 'CommonData/poco/index';

export class JointTextureMapper {
    public static map(data: any, textureSetId: number): Array<JointTexture> {
        if (!data) {
            throw 'No data for mapper: JointTextureMapper';
        }

        if (!textureSetId) {
            return null;
        }

        const matchingJointTextureSet = data.jointTextureSets.find((jts: any) => jts.id == textureSetId);
        if (!matchingJointTextureSet) {
            return null;
        }

        const isFlexibleJoint: boolean = matchingJointTextureSet.name.toLowerCase().includes('flexible');
        return matchingJointTextureSet.jointTextures.map((jt: any) => 
            new JointTexture({
                textureKey: jt.key,
                name: jt.name,
                swatchImageUrl: jt.swatchImageUrl,
                isFlexibleJoint: isFlexibleJoint
            })
        );
    }
} 